<div class="db-hosting-domains" [ngClass]="{'db-domains': domains?.length > 1}">
  <db-loading-screen [ngClass]="{'hidden':!loadPage}"></db-loading-screen>
  <div class="db-hosting-body-wrap" [ngClass]="{'db-page-with-banner': hasHostingBanner}">
    <div class="db-main-wrap db-with-domain-banner">
      <div class="db-domains-header" [ngClass]="{'db-for-search': domains?.length === 1}">
        <div class="db-domains">
          <h1>{{'text_hosting.domains' | dbText}}</h1>
            <p>{{'text_addDomainDesc' | dbText}}</p>
            <span><i class="db-icon db-icon-ds-sidebar-domain"></i>{{ website?.site_url | middleEllipsis: 50 }}</span>
        </div>

        <div class="db-actions">
              <button
                class="ds-btn ds-btn-white-gray-border" [style.width]="'auto'" [style.height]="'36px'"
                (click)="addDomainFromOtherProvider()"
              ><span>{{'text_connectExistingDomain' | dbText}}</span></button>
        </div>
      </div>
        @if (!demoUser && domains?.length > 1) {
          <section class="db-domains-wrapper">
            <db-domains-table
              [listLoading]="listLoading"
              [checkStatusesLoading]="checkStatusesLoading"
              (reloadDomainsEvent)="reloadDomains()">
              <ng-container>
                <ng-container>
                  <div class="list">
                    <db-domain-item
                      *ngFor="let domain of domains"
                      [user]="user" [payments]="payments" [website]="website"
                      (showLoading)="listLoading=$event"
                      (actionDone)="loadDomains()" (primaryActionDone)="updateWebsiteData()"
                      [domain]="domain" [currentSubscription]="userSubscription" [primaryDomain]="primaryDomain"
                      [primaryChanged]="primaryChanged" [checkStatusesLoading]="checkStatusesLoading"
                      [ipv4Address]="hostingInfoData?.hostingBasicInfo?.ip" [companyName]="companyName"
                      [mainDomain]="mainDomain" (onManageClick)="manageDns($event)">
                    </db-domain-item>
                    <db-loading-screen [ngClass]="{'hidden':!listLoading}"></db-loading-screen>
                  </div>
                </ng-container>
              </ng-container>
            </db-domains-table>
          </section>
        }

    </div>
  </div>
</div>
